import styled from 'styled-components';

import { colours } from 'themes/default';

export const Container = styled('div')`
  background: ${colours.Greyscale.White};
  padding: 16px;
  box-shadow: 0 0 30px ${colours.Greyscale.MistGrey};
  margin: ${(props) => props.margin};
`;
